import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const transportLocalitiesService = {};

transportLocalitiesService.getTransportLocalities = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/transport-localities`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand:
        params.expand || "maker,checker,district,province,ward,transport,hub",
      fields: params.fields || defaultFields.join(","),
      "filter[record_status]": "O",
    },
  });
};

// Detail TransportLocalities
transportLocalitiesService.detailTransportLocalities = ({
  transportLocalitiesId,
}) => {
  return fetchV2({
    url: `${env.API_MSP}/transport-localities/${transportLocalitiesId}`,
    method: "get",
  });
};

// Create TransportLocalities
transportLocalitiesService.createTransportLocalities = data => {
  return fetchV2({
    url: `${env.API_MSP}/transport-localities`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Update TransportLocalities
transportLocalitiesService.updateTransportLocalities = ({
  transportLocalitiesId = undefined,
  ...data
}) => {
  return fetchV2({
    url: `${env.API_MSP}/transport-localities/${transportLocalitiesId}`,
    method: "put",
    data,
  });
};

// Delete TransportLocalities
transportLocalitiesService.deleteTransportLocalities =
  transportLocalitiesId => {
    return fetchV2({
      url: `${env.API_MSP}/transport-localities/${transportLocalitiesId}`,
      method: "delete",
    });
  };

export default transportLocalitiesService;
